export enum ApplicationPortalType {
  ClaimCenter = 1,
  WorkshopCenter = 2,
  MobileCenter = 3,
  PortalSupplierCenter = 4
}


